module.exports = __webpack_public_path__ + "img/step23_a_stand_power_insert_stacker_tray.2a315d2f.png";